import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    theme: null
}


const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        getTheme(state, action) {
            state.theme = action.payload
            console.log("get theme", state.theme);
            if(state.theme !== undefined) {
                localStorage.setItem("theme", JSON.stringify(state.theme))
            }
        },
        changeToDark(state, action) {
            console.log("Called change to dark$$$$$$$$$$$")
            state.theme = action.payload
            localStorage.setItem("theme", JSON.stringify("dark"))
        },
        changeToLight(state, action) {
            console.log("Called change to light$$$$$$")
            state.theme = action.payload
            localStorage.setItem("theme", JSON.stringify("light"))
        }
    },
})


export const { getTheme, changeToLight, changeToDark } = themeSlice.actions;

export default themeSlice.reducer